import { AuiChartBase } from './AuiChartBase';
import type { AuiRendererProps } from '../../registry';

export function AuiRadarChart(props: AuiRendererProps) {
  return <AuiChartBase {...props} testId="aui-radar-chart" />;
}
